<template>
<div class="container-fluid">

	<div class="alert alert-info text-center">

		<h1 style="font-size: 22pt;">The <em>Find People</em> module is now integrated into your <router-link to="/contacts"><strong>Contacts Network</strong></router-link>!</h1>

		<p style="font-size: 18pt;margin-bottom: 0;margin-top: 20px;">Head on over there to search for {{ $store.appName }} people/companies, and invite new users to the platform</p>
	</div>

	<!--<toolbar>
		<h2>Find {{searchType}} on {{$store.appName}}</h2>

		<div class="controls">
			<field 
				class="search-type"
				:params="{type:'btn-group',buttons:[
					{text: 'People',value:'People'},{text:'Companies',value:'Companies'}
				],tabStyling:true}" 
				v-model="searchType">		
			</field>
		</div>

	</toolbar>

	<div class="d-flex flex-row flex-wrap">
		<search-bar 
			class='search-bar'
			:placeholder="searchType == 'People' ? 'Search by Name or Email' : 'Search by Company Name'"
			:full-width="true"
			v-on:submit="search">
		</search-bar>
	
	</div>

	<template v-if="searchType == 'People' && !loading">
		<div class="alert alert-info mt-2">

			<div class="text-center">
				<h3 class='alert-heading' style="text-decoration: none;">Can't find who you're looking for, or they're not on {{$store.appName}}?</h3>

				<div class="d-flex justify-content-center invite-buttons">
					<button class="btn btn-primary" v-if="!inviteForm.visible" v-on:click="inviteForm.visible = true">
						<i class="fa fa-paper-plane"></i>
						Send an Invite
					</button>
					<template v-if="getUserRoleType() == 'Admin' || hasModulePermWrite('Users')">
						<div  v-if="!inviteForm.visible" class="align-self-center ml-4 mr-4">
							OR
						</div>
						<router-link to="/employee/new" class="btn btn-primary" >
							<i class="fa fa-plus"></i>
							Create New User Account
						</router-link>
					</template>
				</div>
			</div>

			<form v-if="inviteForm.visible" v-on:submit.prevent="sendInvite">
				
				<field label="Email Address" 
					col-class="stacked" 
					v-model="inviteForm.email">
				</field>

				<div>
					<label v-on:click="inviteForm.joinCompany = true" v-on:change="inviteToggle" class="col-form-label">
						<input type="checkbox" v-model="inviteForm.joinCompany" value="1">
						Invite to {{$store.company.company_name}}
					</label>
				</div>
				
				<field label="Message" 
					col-class="stacked" 
					:params="{type:'textarea'}" 
					v-model="inviteForm.message"
					v-on:change="messageChanged">
				</field>

				<div class="float-right">
					<button type="button" class="btn btn-light" v-on:click="inviteForm.visible = false">
						Cancel
					</button>
					<button type="submit" class="btn btn-primary">
						<i class="fa fa-paper-plane"></i>
						Send
					</button>
				</div>
				<div style="clear: both;"></div>

			</form>
		</div>
		<div v-if="mutatedUsers.length > 0" class="results">
			<p>{{mutatedUsers.length}} possible matches found</p>

			<widget v-for="user in mutatedUsers" :key="user.id">

				<div class="result-image-container">
					<image-panel 
						class="mb-2"
						:readonly="true"
						:image-url="user.profileImageUrl"
						icon="fa-user">	
					</image-panel>


					<div class="d-flex flex-column">

						<button v-if="hasModulePermWrite('Users') && (!user.MyCompany || user.MyCompany && Object.keys(user.MyCompany).length == 0 || user.MyCompany.is_inactive == 1)" class="btn btn-primary" v-on:click="offerEmployment(user)">
							<i class="fa fa-plus"></i>
							Offer Employment
						</button>

						<div v-if="user.MyCompany && Object.keys(user.MyCompany).length > 0 && !user.MyCompany.invite_accepted && user.MyCompany.invite_declined == 0" class="alert alert-info mb-1">
							Employment offer sent

							<div><a href="#" v-on:click.prevent="offerEmployment(user)">Resend offer</a></div>
						</div>

						<button class="btn btn-info mt-1" v-on:click="messageUser(user)">
							<i class="fa fa-envelope"></i>
							Message
						</button>
					</div>

				</div>
				
				<div class="result-main-panel">

					<div v-if="user.is_looking_for_work == 1" class="float-right text-primary">
						<i class="fa fa-podcast"></i>
						Looking for work
					</div>

					<h3 style="text-decoration: none;">
						<router-link :to="'/employee/'+user.slug+'/profile'">
							{{user.first_name}} {{user.last_name}}
						</router-link>
					</h3>

					<field v-if="user.email" label="Email" col-class="col-3" :value="user.email" :readonly="true"></field>

					<field v-if="user.phone" label="Phone" col-class="col-3" :value="user.phone" :readonly="true"></field>

					<field v-if="user.description" label="About" col-class="col-3" :value="user.description" :params="{type:'textarea'}" :readonly="true"></field>

					<h4 style="text-decoration: none;">Employment History on {{$store.appNameProper}}</h4>

					<ul v-if="user.CompanyUser.length > 0" style="list-style: none;padding-left: 10px;">
						<time-line-item>
							Joined <strong>{{$store.appNameProper}}</strong> on {{formatDate(user.created_at)}}
						</time-line-item>
						<time-line-item :key="companyUser.Company.company_name" v-for="companyUser in user.CompanyUser" v-if="'Company' in companyUser && 'company_name' in companyUser.Company && companyUser.invite_accepted">
							Started at <strong>{{companyUser.Company.company_name}}</strong>
							<span v-if="companyUser.Company.created_at"> on {{formatDate(companyUser.invite_accepted)}}</span>
							<template v-if="companyUser.is_inactive == 1">
								<span>, left on {{formatDate(companyUser.disconnect_date)}}</span>
								<span class="text-muted"> (no longer working here)</span>
							</template>
						</time-line-item>
					</ul>
					
					<p v-else>Has not worked anywhere yet</p>

				</div>
					
			</widget>
		</div>
	</template>
	<div v-else-if="!loading" class="results">
		<widget v-for="company in mutatedCompanies" :key="company.slug">

			<div class="result-image-container">
				<image-panel 
					class="mb-2"
					:readonly="true"
					:image-url="company.profileImageUrl"
					icon="fa-user">	
				</image-panel>				

			</div>
			
			<div class="result-main-panel">

				<h3 style="text-decoration: none;">{{company.company_name}}
					<div v-if="company.business_type" class="text-muted"><small>{{ company.business_type }}</small></div>
				</h3>

				<div class="row">
					<div class="col-lg-6 col-md-12">
						<form-group label="Address" col-class="col-4 col-sm-3">
							{{company.address}}<br>
							{{company.city}}, {{company.province}}<br>
							{{company.postal_code}}
						</form-group>
					</div>
					<div class="col-lg-6 col-md-12">

						<field v-if="company.email" label="Email" col-class="col-4 col-sm-3" :value="company.email" :readonly="true"></field>

						<field v-if="company.phone" label="Phone" col-class="col-4 col-sm-3" :value="company.phone" :readonly="true"></field>

						<field v-if="company.description" label="About" col-class="col-4 col-sm-3" :value="company.description" :params="{type:'textarea'}" :readonly="true"></field>
					</div>
				</div>

			</div>
				

		</widget>
	</div>
	<div v-if="loading">
		<div v-for="n in 3" class="skeleton-result"></div>
	</div>
	<p v-if="mutatedUsers.length == 0 && mutatedCompanies.length == 0 && searched">No results found</p>-->

</div>

</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"
import SearchBar from "../components/SearchBar"
import Field from "../components/Field"
import FormGroup from "../components/FormGroup"
import ImagePanel from "../components/ImagePanel"
import Widget from "../components/Widget"
import TimeLineItem from "../components/TimeLineItem"

export default {

	name: 'FindPeople',
	components: {
		Toolbar,
		Field,
		ImagePanel,
		SearchBar,
		Widget,
		FormGroup,
		TimeLineItem
	},
	data() {
		return {
			email: "",
			users: [],
			companies: [],
			searched: false,
			searchScope: 'colleagues',
			searchType: 'People',
			inviteForm: {
				visible: false,
				email: "",
				message: "Hi, we'd like you to join our company on "+this.$store.appNameProper,
				joinCompany: true,
				messageEdited: false
			},
			loading: false
		}
	},
	computed: {
		mutatedUsers() {
			let vm = this

			let mutated = vm.users.map(user => {

				user.profileImageUrl = false
				if ("ProfileImage" in user && user.ProfileImage) {
					user.profileImageUrl = window.apiRoot + "resources/profile-images/"+user.ProfileImage.slug+"/"+user.ProfileImage.filename
				}

				user.MyCompany = user.CompanyUser.find(company => company.tenant_id == vm.$store.userDetails.tenant_id)

				return user
			})

			return mutated
		},
		mutatedCompanies() {
			let vm  = this

			return vm.companies.map(company => {
				company.profileImageUrl = false
				if ("ProfileImage" in company && company.ProfileImage) {
					company.profileImageUrl = window.apiRoot + "resources/profile-images/"+company.ProfileImage.slug+"/"+company.ProfileImage.filename
				}

				return company
			})
		}
	},
	methods: {
		messageUser(user) {
			let vm = this

			this.$bus.$emit("newThread",false,false,this.users,[user.id])
		},
		offerEmployment(user) {
			let vm = this

			vm.postData("CompanyUser/offer-employment",{user_id:user.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Connection invite sent!")
					/*user.CompanyUser = {
						invite_accepted: null,
						invite_declined: 0
					}*/
				}
			})
		},
		messageChanged() {
			this.inviteForm.messageEdited = true
		},
		inviteToggle() {
			if (!this.inviteForm.messageEdited) {
				if (this.inviteForm.joinCompany) 
					this.inviteForm.message = "Hi, we'd like you to join our company on "+this.$store.appNameProper
				
				else 
					this.inviteForm.message = "Hi, we'd like you to join "+this.$store.appNameProper+"!"
				
			}
		},
		sendInvite() {
			let vm = this

			let payload = {
				email: vm.inviteForm.email,
				message: vm.inviteForm.message,
				joinCompany: vm.inviteForm.joinCompany
			}

			this.postData("User/invite",payload,true).then(response => {
				if (response.success) {
					vm.inviteForm.email = ""
					vm.inviteForm.message = ""
					vm.alertSuccess("Invite sent!")
				}
			})
		},
		search(terms) {
			let vm = this

			if (terms.length > 2) {

				terms = encodeURIComponent(terms)

				vm.spinner(true)
				vm.loading = true

				if (vm.searchType == "People") {

					let include = ["ProfileImage",{model:"CompanyUser",include:["Company"]}];

					let filters = []

					//if terms are separate by a space, assume first and last name
					if (terms.indexOf(" ") >= 0) {
						let names = terms.split(" ")

						filters = [
							['first_name',names[0],"and","like"],
							['last_name',names[names.length-1],"and","like"]
						]
					}
					else {
						filters = [
							["first_name",terms,"and","like"],
							["last_name",terms,"or","like"],
							["address",terms,"or","like"],
							["city",terms,"or","like"],
							["phone",terms,"or","like"],
							["email",terms,"or"] //email must be exact match to prevent getting full company roster based on @company.com search
						]
					}

					let payload = {
						include: include,
						filters: filters
					}

					if (this.includeInactive)
						payload.includeFormer = true

					let endpoint = "get"
					if (this.searchScope == 'all') {
						endpoint = "public-search"
						payload.terms = terms
						delete payload.filters
					}
					else {
						payload.includeFormer = true
						payload.includeUnconnected = true
						//payload.filters.push(["CompanyUser.invite_accepted !=",null])
						//payload.filters.push(["CompanyUser.is_inactive",0])
					}

					endpoint = "public-search"

					payload = {
						terms: terms,
					}

					vm.getJSON("User/"+endpoint,payload,true).then(response => {
						vm.spinner(false)
						vm.loading = false

						if (response.success) {
							vm.searched = true
							vm.users = response.data
							vm.companies = []
						}
						
					})
				}
				else {
					let payload = {
						filters: [["company_name",terms,"and","like"]],
						include: ['ProfileImage']
					}

					 vm.getJSON("Company/get",payload,true).then(response => {
					 	vm.spinner(false)
					 	vm.loading = false

					 	if (response.success) {
					 		vm.users = []
					 		vm.companies = response.data
					 	}

					 })
				}
			}
			else {
				vm.users = []
				vm.companies = []
			}
		}
	}

}
</script>

<style type="text/css" scoped>
	.employee-profile {
		margin-top: 20px;
	}

	.results {
		margin-top: 10px;
	}

	.search-bar {
		flex-grow: 1;
	}

	.search-region {
		width: 250px;
	}

	.result-image-container {
		width: 175px;
		margin-right: 30px;
		display: inline-block;
		text-align: center;
		vertical-align: top;
	}

	.result-main-panel {
		display: inline-block;
		width: calc(100% - 215px);
	}

	.result-main-panel h3 a:hover {
		text-decoration: none;
	}

	.skeleton-result {
		border-radius: 4px;
		background-color: #e0e0e0;
		width: 100%;
		height: 120px;
		animation: pulse 3s linear;
		margin-top: 20px;
	}

	.invite-buttons {
		flex-direction: row;
	}

	@keyframes pulse {
		from {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@media (max-width: 600px) {
		.search-type {
			width: 100%;
			margin-bottom: 10px;
		}

		.heading-search-type-container {
			flex-direction: column-reverse!important;
		}
	}

	@media (max-width: 500px) {
		.search-scope {
			width: auto;
			flex-grow: 1
		}

		.result-image-container, .result-main-panel {
			display: block;
			width: 100%;
			margin-right: 0;
			margin-bottom: 10px;
		}

		.result-main-panel .row {
			margin-left: 0;
			margin-right: 0;
		}

		.result-main-panel h3 {
			text-align: center;
		}

		div.invite-buttons {
			flex-direction: column;
		}
	}
</style>